
export async function optimizeImage(files, maxWidth = 1024, maxHeight = 1024, maxSizeKB = 200) {
    const processImage = (file) => {
        return new Promise(async (resolve, reject) => {
            let fileBlob;

            if (typeof file === "string" && file.startsWith("blob:")) {
                const response = await fetch(file);
                fileBlob = await response.blob();
            } else {
                fileBlob = file;
            }
            const reader = new FileReader();
            reader.readAsDataURL(fileBlob);

            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;

                img.onload = () => {
                const canvas = document.createElement("canvas");
                let width = img.width;
                let height = img.height;

                if (width > maxWidth || height > maxHeight) {
                    const scale = Math.min(maxWidth / width, maxHeight / height);
                    width = Math.round(width * scale);
                    height = Math.round(height * scale);
                }

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                const compressImage = (quality) => {
                    return new Promise((resolveQuality) => {
                    canvas.toBlob((blob) => resolveQuality(blob), "image/jpeg", quality);
                    });
                };

                const optimizeSize = async () => {
                    let quality = 0.9;
                    let blob = await compressImage(quality);

                    while (blob.size / 1024 > maxSizeKB && quality > 0.1) {
                    quality -= 0.1;
                    blob = await compressImage(quality);
                    }

                    if (blob.size / 1024 > maxSizeKB) {
                    return reject(new Error("Can't resize."));
                    }
                    resolve(URL.createObjectURL(blob)); 
                };

                optimizeSize();
                };

                img.onerror = () => reject(new Error("Can't read image."));
            };

            reader.onerror = () => reject(new Error("Can't read file."));
        });
    };

    if (Array.isArray(files)) {
        return Promise.all(files.map((file) => processImage(file)));
    } else {
        return processImage(files);
    }
};

export async function uploadImages(images, urls, onProgress) {
    return new Promise(async (resolve, reject) => {
        try {
            for (let i = 0; i < images.length; i++) {
                const blobUrl = images[i];
                const normalUrl = urls[i];

                const response = await fetch(blobUrl);
                const blob = await response.blob();

                const uploadResponse = await fetch(normalUrl, {
                    method: 'PUT',
                    body: blob
                });

                if (!uploadResponse.ok) {
                    return reject("Error during upload.");
                }  
                if (onProgress) onProgress(i + 1, images.length);
            }
            resolve();
        } catch (err) {
            console.error('Error during upload:', err);
            reject(err);
        }
    });
};